import { createSlice } from "@reduxjs/toolkit";
import { ItemType, ModalState } from "../../../utils/types";

export interface InitialState {
  editItemIndex: number | null;
  modal: ModalState;
  itemDialogDetails: ItemType | undefined;
}

const initialState: InitialState = {
  editItemIndex: null,
  modal: {
    isOpen: false,
    component: null,
    options: {},
  },
  itemDialogDetails: undefined,
};

const modalSlice = createSlice({
  name: "modalSlice",
  initialState,
  reducers: {
    setEditItemIndex: (state, { payload }) => {
      state.editItemIndex = payload;
    },
    setModal: (state, { payload }) => {
      state.modal = payload;
    },
    setItemDialogDetails: (state, { payload }) => {
      state.itemDialogDetails = payload;
    },
  },
});

export const { setEditItemIndex, setItemDialogDetails, setModal } =
  modalSlice.actions;

export default modalSlice.reducer;
